/**
 * Issue #178 — 列表「客户」列展示决策（纯函数，便于单测）。
 *
 * 权限由后端控制：仅 ADMIN / SUPER_ADMIN 的响应里才会带 customerNamePlain；
 * 其它角色该字段为 null/undefined。前端只做「有明文用明文，否则降级脱敏，
 * 再否则匿名」的回退，绝不自行解密或伪造明文。
 */
export interface CustomerNameFields {
  customerNamePlain?: string | null;
  customerNameMasked?: string | null;
}

export function resolveCustomerNameDisplay(
  row: CustomerNameFields,
  fallback = '匿名客户',
): string {
  const plain = row.customerNamePlain?.trim();
  if (plain) return plain;
  const masked = row.customerNameMasked?.trim();
  if (masked) return masked;
  return fallback;
}
